import API from './fetch'
import { searchRoomURL, getRoomsInfoURL, recommendationRoomURL } from './url'
import { appendParams } from 'utilities/paramsFormat'

const Rooms = {
  get(data) {
    const url = appendParams(searchRoomURL(), data)
    return API.getData(url)
  },
  getSelectedData(payload) {
    const url = appendParams(getRoomsInfoURL(), { ...payload, include_extra_out_of_stock: true })
    return API.getData(url)
  },
  getRecommendation(payload) {
    const url = appendParams(recommendationRoomURL(), payload)
    return API.getData(url)
  }
}

export default Rooms
